import React from "react";
import { useTranslation } from "react-i18next";
import { parsePhoneNumber } from "react-phone-number-input";
import { ADD_BLACKLIST_PHONE_NUMBER } from "api/api";
import { UTILS } from "utils";
import AppModal from "components/ui/AppModal";
import AppInput from "components/ui/AppInput";
import AppTextArea from "components/ui/AppTextArea";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";

const getInitialPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  try {
    const parsed = parsePhoneNumber(phoneNumber);
    if (parsed?.nationalNumber) return parsed.nationalNumber;
  } catch (e) {}
  return String(phoneNumber).replace(/\D/g, "");
};

const BlockOrderPlacerModal = ({
  visible,
  onClose,
  phoneNumber,
  countryCode,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [values, setValues] = React.useState({
    phoneNumber: "",
    reason: "",
  });
  const [errors, setErrors] = React.useState({
    phoneNumber: "",
    reason: "",
  });

  React.useEffect(() => {
    if (!visible) return;
    setValues({
      phoneNumber: getInitialPhoneNumber(phoneNumber),
      reason: "",
    });
    setErrors({
      phoneNumber: "",
      reason: "",
    });
  }, [visible, phoneNumber]);

  const validate = () => {
    const nextErrors = { phoneNumber: "", reason: "" };
    let isValid = true;

    if (!values.phoneNumber?.trim()) {
      nextErrors.phoneNumber = t("Field is required");
      isValid = false;
    }

    if (!values.reason?.trim()) {
      nextErrors.reason = t("Please enter a reason");
      isValid = false;
    }

    setErrors(nextErrors);
    return isValid;
  };

  const handleModalOk = async () => {
    if (!validate()) return;
    try {
      setLoading(true);
      const userDetail = UTILS.getCurrentUser();

      let parsedCountryCode = String(countryCode || "").replace(/\D/g, "");
      let nationalNumber = values.phoneNumber.trim();

      try {
        const parsed = parsePhoneNumber(phoneNumber);
        if (parsed?.countryCallingCode) {
          parsedCountryCode = parsed.countryCallingCode;
        }
      } catch (e) {}

      const payload = {
        phoneNumber: nationalNumber,
        countryCode: parsedCountryCode,
        reason: values.reason.trim(),
        brandId: userDetail.brandId,
        isGlobal: false,
      };

      await ADD_BLACKLIST_PHONE_NUMBER(payload);
      UTILS.successNotification(t("Phone number added to blacklist"));
      onClose?.();
      onSuccess?.();
    } catch (error) {
      UTILS.errorNotification(error?.message || t("Please try again later!"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppModal
      open={visible}
      onClose={onClose}
      title={t("Add Blacklisted Phone Number")}
      width={520}
    >
      <div className="space-y-4">
        <AppInput
          label={t("Phone Number")}
          type="number"
          value={values.phoneNumber}
          disabled={true}
          onChange={(e) =>
            setValues((prev) => ({
              ...prev,
              phoneNumber: e.target.value,
            }))
          }
          error={errors.phoneNumber}
          mandatory={true}
          placeholder={t("Enter phone number")}
        />
        <AppTextArea
          label={t("Reason")}
          value={values.reason}
          onInput={(e) =>
            setValues((prev) => ({
              ...prev,
              reason: e.target.value,
            }))
          }
          error={errors.reason}
          required={true}
          rows={4}
          placeholder={t("Enter reason for blacklisting")}
        />
        <div className="flex justify-end gap-2 pt-2">
          <AppOutlineButton onClick={onClose}>{t("Cancel")}</AppOutlineButton>
          <AppButton onClick={handleModalOk} loading={loading}>
            {t("Add")}
          </AppButton>
        </div>
      </div>
    </AppModal>
  );
};

export default BlockOrderPlacerModal;